import React, {
  useContext,
} from 'react';
import {
  MultiMediaResponse,
} from 'dtos';
import {
  FileViewerContext,
} from 'pages/Dashboard/contexts/fileViewer';
import MediaPreview from 'pages/Dashboard/components/MediaPreview';

export default function usePreviewMediaClick() {
  const { openDialog } = useContext(FileViewerContext);
  return (media: MultiMediaResponse) => {
    openDialog({
      title: media?.fileName ?? '',
      content: (<MediaPreview media={media} />),
    });
  };
}
